module.exports = __webpack_public_path__ + "static/img/nengli2.9177bda8.png";